import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import styles from './Footer.module.css';
import { useTranslation } from "react-i18next";



export default function Footer() {

  const { t } = useTranslation();

  return (
    <div className={styles.Footer}>
      <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
        <section className='d-flex justify-content-center justify-content-lg-between border-bottom'>
          <MDBContainer className='text-center text-md-start mt-3'>
            <MDBRow className='mt-3'>
              <MDBCol md='12' xl='12' className='mx-auto' align='center'>
                <p>
                  <MDBIcon color='secondary' icon='building' className='me-3' />
                  OMAX Consulting AS
                </p>
                <p>
                  <MDBIcon color='secondary' icon='home' className='me-3' />
                  Tyholtveien 69 D, 7052 Trondheim, {t("Norway")}
                </p>
                <p>
                  <MDBIcon color='secondary' icon='envelope' className='me-3' />
                  <a href="mailto:post@omaxconsulting.no">
                    post@omaxconsulting.no
                  </a>
                </p>
                <p>
                  <MDBIcon color='secondary' icon='briefcase' className='me-3' />
                  NO 935 422 809 MVA
                </p>
              </MDBCol>
              {/*<MDBCol md='4' lg='2' xl='2' className='mx-auto mb-md-0 mb-4'>
              </MDBCol>*/}
            </MDBRow>
          </MDBContainer>
        </section>

        <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
          <a className='text-reset fw-bold' href='https://www.omaxconsulting.no/'>
            OMAX Consulting AS
          </a>
          &nbsp;© 2025
        </div>
      </MDBFooter>
    </div>
  );
}